import React from 'react';
import RegisterView from 'components/organisms/register_view';

const Register = () => {
  return (
    <div className="container-fluid" style={{ backgroundColor: '#f0f1f2' }}>
      <div className="row">
        <div className="col-md-12 p-0">
          <RegisterView />
        </div>
      </div>
    </div>
  );
};

export default Register;
